import type { ContentFragment } from '@oneaudi/falcon-tools';

export interface FalconContent extends Partial<ContentFragment> {
  __type: 'aem-headless';
  fields: {
    is360ViewEnabled: boolean;
    cta360ViewButtonLabel: string;
  };
}

export interface AppContent {
  __type?: 'default';
  is360ViewEnabled: boolean;
  cta360ViewButtonLabel: string;
}

export const mapContent = (content?: AppContent | FalconContent): AppContent => {
  if (!content) {
    return {
      is360ViewEnabled: false,
      cta360ViewButtonLabel: '',
    };
  }

  if (content.__type !== 'aem-headless') {
    return { ...content };
  }

  return normalizeContent(content);
};

const normalizeContent = (content: FalconContent): AppContent => {
  const { is360ViewEnabled, cta360ViewButtonLabel } = content.fields;

  const formattedContent = {
    is360ViewEnabled,
    cta360ViewButtonLabel,
  };

  return formattedContent;
};
